import { CSSObject } from '@emotion/core';

import { useMedia } from '@scripts/hooks';
import { themeColor } from '@scripts/themes/cssVars';

export const getContainerStyles = ({
    xs,
    md,
    isLoading,
}: Pick<ReturnType<typeof useMedia>, 'md' | 'xs'> & { isLoading?: boolean }): CSSObject => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    ...(isLoading
        ? {
              position: 'relative',
              minHeight: 230,
              padding: 0,
              backgroundColor: themeColor.backgroundEmpty,
              [md]: { minHeight: 188 },
              [xs]: { minHeight: 180 },
          }
        : {
              padding: '98px 0 0',
              [md]: { padding: '48px 0 12px' },
              [xs]: { padding: '48px 0 24px' },
          }),
});

export const getContentWrapperStyles = ({ xs }: Pick<ReturnType<typeof useMedia>, 'xs'>): CSSObject => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    gap: '24px',
    maxWidth: '410px',
    [xs]: {
        gap: '12px',
    },
});

export const getTextContainerStyles = ({ xs }: Pick<ReturnType<typeof useMedia>, 'xs'>): CSSObject => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
    [xs]: {
        gap: '4px',
    },
});

export const getTitleStyles = ({ md, xs }: Pick<ReturnType<typeof useMedia>, 'md' | 'xs'>): CSSObject => ({
    margin: 0,
    fontSize: '24px',
    fontWeight: 500,
    lineHeight: 1.2,
    color: themeColor.textBlack,
    [md]: {
        fontSize: '20px',
    },
    [xs]: {
        fontSize: '16px',
    },
});

export const getDescriptionStyles = ({ md }: Pick<ReturnType<typeof useMedia>, 'md'>): CSSObject => ({
    margin: 0,
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '22px',
    color: themeColor.textBlack,
    [md]: {
        fontSize: '14px',
    },
});

export const getButtonStyles = (): CSSObject => ({
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '22px',
    color: themeColor.white,
    padding: '14px 24px !important',
    backgroundColor: themeColor.green,
});
